import AcademicOfferModule from './containers/academicOfferModule'

export {default as AcademicOfferModuleLayout} from './components/academicOfferModuleLayout'

export default AcademicOfferModule
